<template>
  <path d="M8.0625 10.3125L12 14.25L15.9375 10.3125" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 3.74725V14.2473" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 12.75V19.5C21 19.6989 20.921 19.8897 20.7803 20.0303C20.6397 20.171 20.4489 20.25 20.25 20.25H3.75C3.55109 20.25 3.36032 20.171 3.21967 20.0303C3.07902 19.8897 3 19.6989 3 19.5V12.75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</template>
